import { VFC } from 'react'
import styles from './RatingCustomComponent.module.scss'

interface Props {
  averageRating: number
  maxStar: number
  starSize?: number
}

const RatingCustomComponent: VFC<Props> = ({ averageRating, maxStar = 5, starSize }: Props) => {
  const width = (averageRating / maxStar) * 100

  const startStyle = {}
  if (starSize) {
    startStyle['fontSize'] = `${starSize}px`
  }

  return (
    <div className={styles.ratingBox}>
      <span className={styles.ratingBackground}>
        {Array(maxStar)
          .fill(0)
          .map((val, index) => {
            return (
              <span
                className={`${styles.ratingStar} ${styles.ratingBackgroundStar}`}
                style={startStyle}
                key={index}
              >
                ★
              </span>
            )
          })}
      </span>
      <span
        className={styles.ratingForeground}
        style={{
          width: `${width}%`,
        }}
      >
        {Array(maxStar)
          .fill(0)
          .map((val, index) => {
            return (
              <span
                className={`${styles.ratingStar} ${styles.ratingForegroundStar}`}
                style={startStyle}
                key={index}
              >
                ★
              </span>
            )
          })}
      </span>
    </div>
  )
}

export default RatingCustomComponent
